// Module
var code = "<h2 class=\"interiorSectionHeading\"> Face ID and Touch ID </h2> <p>Use Face ID or Touch ID to sign in to your account faster and easier than ever.</p> ";
// Exports
export default code;